jQuery(document).ready(async function ($) {
    const params = new URLSearchParams(window.location.search);
    let products = [];
    var lang = $("html").attr("lang");

    function normalizeString(str) {
        return str
            ?.toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .trim();
    }

    function getOrderedMatchPosition(text, words) {
        let lastIndex = -1;
        for (let word of words) {
            const index = text.indexOf(word, lastIndex + 1);
            if (index === -1) return Infinity;
            lastIndex = index;
        }
        return lastIndex;
    }

    function smartSearch(keyword, items) {
        keyword = normalizeString(keyword);
        const words = keyword.split(/\s+/);

        let results = items.filter(product =>
            normalizeString(product.title).includes(keyword)
        );

        if (results.length === 0) {
            results = items.filter(product => {
                const title = normalizeString(product.title);
                return getOrderedMatchPosition(title, words) !== Infinity;
            });
        }

        // if (results.length === 0) {
        //     results = items.filter(product => {
        //         const sku = normalizeString(product?.sku || '');
        //         return sku.includes(keyword);
        //     });
        // }
        // if (results.length === 0) {
        //     results = items.filter(product => {
        //         const references = product?.reference || [];
        //         return references.some(ref => normalizeString(ref).includes(keyword));
        //     });
        // }

        if (results.length === 0) {
            if (keyword.length >= 5) {
                let variantMatches = [];

                items.forEach(product => {
                    if (product.variants && product.variants.length > 0) {
                        product.variants.forEach(variant => {
                            const ref = normalizeString(variant.sku || "");

                            if (ref.includes(keyword)) {
                                variantMatches.push({
                                    ...product,                   
                                    price: variant.price,  
                                    discount_price: variant.discount_price,                  
                                    images: [{ src: variant.image }],
                                    handle: product.handle,
                                    reference_found: variant.sku,
                                    variant_id: variant.id,
                                    _isVariant: true 
                                });
                            }
                        });
                    }
                });

                if (variantMatches.length > 0) return variantMatches;
            }else{
                // results = items.filter(product => {
                //     const productSKU = normalizeString(product.sku || "");
                //     return productSKU.includes(keyword);
                // });
                results = items.filter(product => {
                    const productSKU = normalizeString(product.sku || "");
                    const variantMatch = (product.variants || []).some(v =>
                        normalizeString(v.sku || "").includes(keyword)
                    );

                    if (productSKU && productSKU.includes(keyword)) return true;

                    if (variantMatch) return true;

                    return false;
                });
            } 
        }

        results.sort((a, b) => {
            const titleA = normalizeString(a.title);
            const titleB = normalizeString(b.title);

            const fullMatchA = titleA.indexOf(keyword);
            const fullMatchB = titleB.indexOf(keyword);
            if (fullMatchA !== fullMatchB) return fullMatchA - fullMatchB;

            const posA = getOrderedMatchPosition(titleA, words);
            const posB = getOrderedMatchPosition(titleB, words);
            if (posA !== posB) return posA - posB;

            return titleA.length - titleB.length;
        });

        return results;
    }

    function formatPrice(price) {
        const newPrice = Math.round(price / 100);
        return new Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(newPrice);
    }

    function getEffectivePrice(product) {
        const price = Number(product.price || 0);
        const discount = (product.discount_price === null || product.discount_price === undefined)
            ? null
            : Number(product.discount_price);
        return (discount && discount < price) ? discount : price;
    }

    function applyFilters(products) {
        let filtered = [...products];
        const selectedType = (params.get("product_type_search") || "").trim().toLowerCase();

        if (selectedType !== "*" && selectedType !== "") {
            filtered = filtered.filter(p =>
                p.product_type &&
                p.product_type.toLowerCase().trim() === selectedType
            );
        }

        const sortBy = (params.get("sort_by") || "").trim().toLowerCase();
        if (sortBy === "price-ascending") {
            filtered.sort((a, b) => getEffectivePrice(a) - getEffectivePrice(b));
        } else if (sortBy === "price-descending") {
            filtered.sort((a, b) => getEffectivePrice(b) - getEffectivePrice(a));
        }

        return filtered;
    }

    async function fetchWithTimeout(url, ms = 15000) {
        const controller = new AbortController();
        const id = setTimeout(() => controller.abort(), ms);
        try {
            const res = await fetch(url, { method: 'GET', cache: 'no-store', signal: controller.signal });
            clearTimeout(id);
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            return await res.json();
        } catch (err) {
            clearTimeout(id);
            throw err;
        }
    }

    const keyword = (params.get("q") || "").trim().toLowerCase();

    (async () => {
        try {
            const totalPages = 10;
            const lang = document.documentElement.lang;

            const urls = Array.from({ length: totalPages }, (_, i) => {
                const page = i + 1;

                if (lang === "en") {
                    return `/en/pages/product-json?page=${page}`;
                }

                if (lang === "de") {
                    return `/de/pages/product-json?page=${page}`;
                }

                return `/pages/product-json?page=${page}`;
            });

            const results = await Promise.allSettled(urls.map(u => fetchWithTimeout(u)));

            products = results.flatMap((r) => {
                if (r.status !== 'fulfilled') {
                    return [];
                }
                const data = r.value;
                if (Array.isArray(data)) return data;
                if (Array.isArray(data.products)) return data.products;
                return [];
            });

            const matched = smartSearch(keyword, products);
            let filtered = applyFilters(matched);

            if (filtered.length === 0) {
                let notfound = '';
                if (lang === "en") {
                    document.title = "Search results: " + filtered.length + " Search Results";
                    notfound = "No products were found matching your selection.";
                } else if (lang === "de") {
                    document.title = "Suchergebnisse: " + filtered.length + " Suchergebnisse";
                    notfound = "Keine Produkte wurden gefunden, die Ihrer Auswahl entsprechen.";
                } else {
                    document.title = "Résultats de la recherche: " + filtered.length + " résultats de recherche";
                    notfound = "Aucun produit trouvé correspondant à votre sélection.";
                }
                $('.t4s_box_pr_grid').html(`
                    <div class="t4s-no-result-product t4s-d-flex t4s-align-items-center" style="width: calc(100% - 30px);">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="18" height="18">
                        <path d="M506.3 417l-213.3-364c-16.33-28-57.54-28-73.98 0l-213.2 364C-10.59 444.9 9.849 480 42.74 480h426.6C502.1 480 522.6 445 506.3 417zM232 168c0-13.25 10.75-24 24-24S280 154.8 280 168v128c0 13.25-10.75 24-23.1 24S232 309.3 232 296V168zM256 416c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 401.9 273.4 416 256 416z"></path>
                        </svg>
                        ${notfound}
                    </div>
                `);
                return;
            }

            let currentPage = parseInt(params.get("page"), 10) || 1;
            const perPage = 12;

            const renderPage = (page, filteredProducts = filtered) => {
                const totalFilteredPages = Math.ceil(filteredProducts.length / perPage);
                if (lang === "en") {
                    document.title = "Search results: " + filteredProducts.length + " Search Results";
                } else if (lang === "de") {
                    document.title = "Suchergebnisse: " + filteredProducts.length + " Suchergebnisse";
                } else {
                    document.title = "Résultats de la recherche: " + filteredProducts.length + " résultats de recherche";
                }
                // console.log('totalFilteredPages',filteredProducts.length );
                const start = (page - 1) * perPage;
                const end = start + perPage;
                const productsToShow = filteredProducts.slice(start, end);

                const html = productsToShow.map(product => {
                    const price = product.price || 0;
                    const compareAtPrice = product.discount_price || null;
                    const formattedPrice = formatPrice(price);
                    const formattedDiscountPrice = compareAtPrice ? formatPrice(compareAtPrice) : null;
                    const handle = product.handle;
                    const productId = product.id;
                    const vendor = product.vendor || "Vendor";

                    // const productUrl = document.documentElement.lang === "en"
                    //     ? `/en/products/${handle}`
                    //     : `/products/${handle}`;

                    let productUrl = `/products/${product.handle}`;

                    if (product._isVariant && product.variant_id) {
                        productUrl = `/products/${product.handle}?variant=${product.variant_id}`;
                    }

                    if (document.documentElement.lang === "en") {
                        productUrl = `/en/products/${product.handle}`;

                        if (product._isVariant && product.variant_id) {
                        productUrl = `/en/products/${product.handle}?variant=${product.variant_id}`;
                        }
                    }

                    if (document.documentElement.lang === "de") {
                        productUrl = `/de/products/${product.handle}`;

                        if (product._isVariant && product.variant_id) {
                        productUrl = `/de/products/${product.handle}?variant=${product.variant_id}`;
                        }
                    }

                    const dataOptions = {
                        id: productId,
                        cusQty: "1",
                        available: true,
                        handle: handle,
                        isDefault: false,
                        customBadge: null,
                        customBadgeHandle: null,
                        dateStart: Math.floor(Date.now() / 1000),
                        compare_at_price: compareAtPrice,
                        price: price,
                        isPreoder: false,
                        isExternal: false,
                        alt: "-1",
                        isGrouped: false,
                        maxQuantity: 9999
                    };
                    const priceHtml =
                    price == 0
                        ? (
                            document.documentElement.lang === 'fr'
                                ? 'Prix sur demande'
                                : document.documentElement.lang === 'de'
                                    ? 'Preis auf Anfrage'
                                    : 'Price on request'
                        )
                        : `<span class="notranslate ht-money">${formatPrice(price)}</span>`;
                    return `
                    <div class="t4s-product t4s-pr-grid t4s-pr-style1 t4s-pr-${productId} t4s-col-item is-t4s-pr-created"
                        data-product-options='${JSON.stringify(dataOptions).replace(/'/g, "&apos;")}'>

                        <div class="t4s-product-wrapper" timeline hdt-reveal="slide-in" observed>
                        <div class="t4s-product-inner t4s-pr t4s-oh">
                            <div class="t4s-product-img">
                                <div class="product-slider-custom">
                                    ${(Array.isArray(product.images) && product.images.length > 0
                        ? product.images.map((img) => `
                                            <div class="product-slide-custom">
                                                <img src="${img.src}&width=500" alt="${product.title}" loading="lazy" width="500" height="500" class="t4s-product-main-img" />
                                            </div>
                                            `).join('')
                        : `
                                            <div class="product-slide-custom">
                                                <img src="https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png"
                                                alt="placeholder" loading="lazy" width="500" height="500" class="t4s-product-main-img" />
                                            </div>
                                        `
                    )}
                                </div>
                            </div>

                            ${compareAtPrice && compareAtPrice < price
                            ? `<span class="product-label sale" style="position: absolute; background: #f18282; color: #fff; padding: 10px; top:0; right:3px;">
                                    -30%
                                </span>`
                            : ''
                        }

                            <div class="t4s-product-btns">
                                <a href="${productUrl}" class="t4s-pr-item-btn t4s-pr-addtocart t4s-tooltip-actived" data-id="${productId}">
                                    <span class="t4s-svg-pr-icon"><svg viewBox="0 0 24 24"><use xlink:href="#t4s-icon-atc"></use></svg></span>
                                    <span class="t4s-text-pr">Achat rapide</span>
                                </a>
                            </div>

                            <div class="t4s-product-btns2 wishlist-collection">
                                <p class="wishlist-collection-custom">
                                    <span class="t4s-svg-pr-icon icon-no-add-wishlist add-wishlist-in-collection"
                                    data-id="${productId}"
                                    data-title="${product.title}"
                                    data-price="${formattedPrice}"
                                    data-price-sale="${formattedDiscountPrice || formattedPrice}"
                                    data-product-sale="productSale"
                                    data-handle="${productUrl}">
                                    <svg viewBox="0 0 24 24">
                                        <use xlink:href="#t4s-icon-wis"></use>
                                    </svg>
                                    </span>
                                    <span class="t4s-svg-pr-icon icon-add-wishlist remove-wishlist-in-collection"
                                    data-id="${productId}">
                                    <svg viewBox="0 0 24 24" class="t4s-svg-wis is-ic--added">
                                        <use xlink:href="#t4s-icon-wis-added"></use>
                                    </svg>
                                    </span>

                                    <span class="t4s-text-pr text-no-add-wishlist">
                                    Ajouter à la liste de souhaits
                                    </span>
                                    
                                    <span class="t4s-text-pr text-add-wishlist">
                                    Supprimer la liste de souhaits
                                    </span>
                                </p>
                            </div>

                            <a class="t4s-full-width-link" href="${productUrl}"></a>
                        </div>

                        <div class="t4s-product-info">
                            <div class="t4s-product-info__inner">
                                <h3 class="t4s-product-title">
                                    <a href="${productUrl}">${product.title}</a>
                                </h3>
                                <div class="a2 t4s-product-price" data-pr-price="">
                                    ${
                        compareAtPrice && compareAtPrice < price
                            ? `
                                        <span class="original-price" style="text-decoration: line-through; color: #333;">
                                            <span class="notranslate ht-money">${formattedPrice}</span>
                                        </span>
                                        <span class="discounted-price" style="color: #e74c3c; margin-left: 5px;">
                                            <span class="notranslate ht-money">${formattedDiscountPrice}</span>
                                        </span>
                                        `
                            : `
                                        <span class="discounted-price">
                                            <span class="notranslate ht-money">${priceHtml}</span>
                                        </span>
                                        `
                    }
                                </div>
                            </div>
                            <div class="t4s-product-btns t4s-product-info__btns">
                                <a href="${productUrl}" class="t4s-pr-item-btn t4s-pr-addtocart" data-id="${productId}">
                                    <span class="t4s-svg-pr-icon"><svg viewBox="0 0 24 24"><use xlink:href="#t4s-icon-atc"></use></svg></span>
                                    <span class="t4s-text-pr">Achat rapide</span>
                                </a>
                            </div>
                        </div>
                        </div>
                    </div>`;
                }).join('');

                $('.t4s_box_pr_grid').html(html);
                renderPagination(page, totalFilteredPages, filteredProducts);
            };

            const renderPagination = (currentPage, totalFilteredPages, filteredProducts) => {
                if (totalFilteredPages <= 1) return;

                let paginationHtml = `
                <div class="t4s-row t4s-prs-footer t4s-has-btn-default t4s-text-center">
                <link rel="stylesheet" href="//julietteparisshop.myshopify.com/cdn/shop/t/50/assets/pagination.css" media="all" onload="this.media='all'">
                <noscript>
                    <link href="//julietteparisshop.myshopify.com/cdn/shop/t/50/assets/pagination.css" rel="stylesheet" type="text/css" media="all">
                </noscript>
                <div class="t4s-pagination-wrapper t4s-w-100">
                    <nav class="t4s-pagination" role="navigation" aria-label="Pagination">
                    <ul class="t4s-pagination__list list-unstyled" role="list">
                `;

                // Previous button
                if (currentPage > 1) {
                    paginationHtml += `
                    <li>
                        <a href="#" class="t4s-pagination__item link pagination__item--prev pagination__item-arrow" data-page="${currentPage - 1}" aria-label="Précédent">
                        Précédent
                        </a>
                    </li>
                    `;
                }

                let maxPagesToShow = 5;
                if (currentPage == 1) {
                    maxPagesToShow = 3;
                }
                const startPage = Math.max(1, currentPage - 2);
                const endPage = Math.min(totalFilteredPages, startPage + maxPagesToShow - 1);

                if (startPage > 1) {
                    paginationHtml += `
                    <li><a href="#" class="t4s-pagination__item link t4s-pagination__item_trigger" data-page="1">1</a></li>
                    <li><span class="t4s-pagination__item">…</span></li>
                    `;
                }

                for (let i = startPage; i <= endPage; i++) {
                    paginationHtml += `
                    <li>
                        ${i === currentPage
                            ? `<span class="t4s-pagination__item pagination__item--current" aria-current="page" aria-label="Page ${i}">${i}</span>`
                            : `<a href="#" class="t4s-pagination__item link" data-page="${i}" aria-label="Page ${i}">${i}</a>`
                        }
                    </li>
                    `;
                }

                if (endPage < totalFilteredPages) {
                    paginationHtml += `
                    <li><span class="t4s-pagination__item">…</span></li>
                    <li><a href="#" class="t4s-pagination__item link" data-page="${totalFilteredPages}">${totalFilteredPages}</a></li>
                    `;
                }

                // Next button
                if (currentPage < totalFilteredPages) {
                    paginationHtml += `
                    <li>
                        <a href="#" class="t4s-pagination__item link pagination__item--prev pagination__item-arrow" data-page="${currentPage + 1}" aria-label="Suivant">
                        Suivant
                        </a>
                    </li>
                    `;
                }

                paginationHtml += `
                    </ul>
                    </nav>
                </div>
                </div>
                `;

                $('[data-ntajax-container] .t4s-prs-footer').remove();
                $('[data-ntajax-container]').append(paginationHtml);

                // Bind pagination click events
                $('.t4s-pagination__item.link').on('click', function (e) {
                    e.preventDefault();
                    const page = parseInt($(this).data('page'));
                    if (!isNaN(page)) {
                        currentPage = page;
                        const newUrl = new URL(window.location.href);
                        newUrl.searchParams.set('page', page);
                        window.history.pushState({ path: newUrl.href }, '', newUrl.href);
                        renderPage(currentPage, filteredProducts);
                    }
                    initProductSlider();
                });
            };

            renderPage(currentPage);
            initProductSlider();
            $('.t4s_box_pr_grid').show();

            // SORT BUTTON CLICK
            $("body").on("click", ".t4s-dropdown__sortby .t4s-dropdown__content button", function (e) {
                e.preventDefault();
                e.stopPropagation();

                const value = $(this).data('value');
                const newUrl = new URL(window.location.href);
                newUrl.searchParams.set('sort_by', value);
                newUrl.searchParams.set('page', 1);
                window.history.pushState({}, '', newUrl);

                params.set('sort_by', value);
                params.set('page', 1);

                const matched = smartSearch(keyword, products);
                filtered = applyFilters(matched);

                currentPage = 1;
                renderPage(currentPage, filtered);
                initProductSlider();
            });

        } catch (err) {
            console.error("Error:", err);
        }
    })();


    function initProductSlider() {
        $('.product-slider-custom').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: true,
            lazyLoad: 'ondemand',
        });
    }

    $('.t4s-layout-switch-wrapper button').click(function () {
        if ($('.product-slider-custom').hasClass('slick-initialized')) {
            $('.product-slider-custom').slick('unslick');
        }
        initProductSlider();
    });
});
